import { alpha, darken, lighten, makeStyles } from '@material-ui/core';
import { isNil } from 'lodash';

import { NO_LANDING_PAGE_DEFAULT } from './GroupsAdminConstants';

export const useGroupAdminStyles = makeStyles((theme) => ({
    selectorWrapper: {
        marginTop: 16,
    },
    selectField: {
        marginRight: '16px',
        '& .MuiInput-root': {
            width: 280,
        },
    },
    drillInToggle: {
        marginTop: '8px',
    },
    pageIconColumnWrapper: {
        '& .MuiSvgIcon-root': {
            color:
                theme.palette.type === 'light'
                    ? lighten(alpha(theme.palette.divider, 1), 0.35)
                    : darken(alpha(theme.palette.divider, 1), 0.25),
        },
    },
    detailsInfoWrapper: {
        marginBottom: 24,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    detailsInfoIcon: {
        color: theme.palette.alert.info,
        fontSize: 24,
    },
    removeDefaultGroupDialogContainer: {
        maxWidth: 640,
    },
}));

/**
 * Determines the correct landing page value to post to the groups API on form submit
 * @param {{ landingPage: string | null }} formData from data from api used when modifying a record
 * @param {{ landingPage: string | null }} submitData submit data form form
 * @returns the value to post for landing page to the groups api
 */
export function getLandingPageFromForm(formData, submitData) {
    if (!isNil(submitData?.landingPage)) {
        return submitData.landingPage === NO_LANDING_PAGE_DEFAULT.value ? null : submitData.landingPage;
    }

    return formData?.landingPage;
}
